import axios from 'axios'
import config from './config'
import swal from 'sweetalert'
import auth from '../token'

export default {
  async request(method, uri, data, token) {
    if (!method) {
      console.error('API function call requires method argument')
      return
    }

    if (!uri) {
      console.error('API function call requires uri argument')
      return
    }

    const headers = config.headers
    const url = config.serverURI + uri
    if (localStorage.getItem('token')) {
      headers.Authorization = `${'Bearer ' + localStorage.getItem('token')}`
    }

    if (token === 'restore') {
      delete headers.Authorization;
    }

    return await axios({ method, url, data, headers: headers, timeout: '50000' }).catch(error => {
      // if (error.toString().includes('401')) {
      //   swal('¡Algo salio mal!', 'Usuario/contraseña incorrecto', 'warning')
      //   setTimeout(() => {
      //     auth.logout();
      //   }, 2000)
      // } else if (error.toString().includes('403')) {
      //   swal('¡Algo salio mal!', 'Usuario no autorizado', 'warning')
      //   setTimeout(() => {
      //     auth.logout();
      //   }, 2000)
      // } else {
      //   swal('¡Algo salio mal!', 'Consulte al administrador', 'warning')
      // }
    }) // tiemout 50 seg
  }
}
